import socials from '../resources/socials.json';

const Socials = ({ className = '' }: { className?: string }) => (
    <ul className={`flex flex-wrap gap-x-5 gap-y-2 ${className}`}>
        {socials.map(s => (
            <li key={s.name}>
                <a href={s.url} target="_blank" rel="noreferrer" className="hover:text-accent transition-colors">{s.name}</a>
            </li>
        ))}
    </ul>
);

export default Socials;
